import './ExhibitorsPage.css'

import React from 'react'
import Markdown from 'react-markdown'
import { withProps } from 'recompose'

import { getExhibitorsContent } from '../app/selectors'
import content from '../content'

const ExhibitorsPage = ({ list }) => (
  <div>
    <Markdown source={list.text} />
    {list.items.map(item => (
      <div className="ExhibitorsPage-item" key={item.name}>
        {item.link ? (
          <a href={item.link}>
            <img src={item.img} alt={item.name} />
          </a>
        ) : (
          <img src={item.img} alt={item.name} />
        )}
        <Markdown source={item.text} />
      </div>
    ))}
  </div>
)

const exhibitorsContent = getExhibitorsContent(content)

const withPageContent = withProps({
  list: exhibitorsContent.list,
})

export default withPageContent(ExhibitorsPage)



// WEBPACK FOOTER //
// ./src/containers/ExhibitorsPage.js